import api from "./api";

const ConfigService = {
  async getConfig() {
    const r = await api.get("/config");
    return r.data;
  },
};

export default ConfigService;
